import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const services = [{
  name: 'Knotless Braids',
  price: '$180.00',
  image: 'https://cdn.magicpatterns.com/uploads/1R6hUwZoQpV1Q9E5wtoWab/high-quality_image_of_a_woman_with_long,_neat_braids,_styled_elegantly._She_is_seated_in_a_confident_pose,_looking_slightly_over_her_shoulder._The_lighting_highlights_her_smooth_skin_and_detailed_braiding,_reinforci.jpg'
}, {
  name: 'Goddess Braids',
  price: '$150.00',
  image: 'https://cdn.magicpatterns.com/uploads/ifwbePQD9khYJ7wr1HWV9G/high-quality_image_of_a_woman_with_long,_neat_braids,_styled_elegantly._She_is_seated_in_a_confident_pose,_looking_slightly_over_her_shoulder._The_lighting_highlights_her_smooth_skin_and_detailed_braiding,_reinf_(2).jpg'
}, {
  name: 'Cornrows with Design',
  price: '$90.00',
  image: 'https://cdn.magicpatterns.com/uploads/dDfmnrpbhkNGfQYfrcWW59/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision._(1).jpg'
}, {
  name: 'Boho Braids',
  price: '$200.00',
  image: 'https://cdn.magicpatterns.com/uploads/4xqsUeWmPjM9HmcsPxbT1J/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision..jpg'
}, {
  name: 'Faux Locs',
  price: '$220.00',
  image: 'https://cdn.magicpatterns.com/uploads/uTAYRJKYme2VwCTNDZxgZp/high-quality_image_of_a_woman_with_long,_neat_braids,_styled_elegantly._She_is_seated_in_a_confident_pose,_looking_slightly_over_her_shoulder._The_lighting_highlights_her_smooth_skin_and_detailed_braiding,_reinf_(3).jpg'
}];
export function HomeServices() {
  return <section id="services" className="py-10 md:py-14 bg-cream text-near-black" data-id="element-237">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-238">
        {/* 2-Column Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12 gap-6" data-id="element-239">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-4xl md:text-5xl text-warm-brown shrink-0" data-id="element-240">
            Our Services
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-near-black/70 font-body text-sm md:text-base max-w-xl leading-relaxed" data-id="element-241">
            Whether you're going for a protective look, a bold transformation,
            or a signature everyday style — our expert braiders have you
            covered. Choose your look, reserve your time, and let us handle the
            rest.
          </motion.p>
        </div>

        {/* Slider Controls (Visual Only) */}
        <div className="flex justify-end gap-4 mb-6" data-id="element-242">
          <button className="w-10 h-10 rounded-full border border-warm-brown/20 flex items-center justify-center text-warm-brown hover:bg-brand-gold hover:text-cream hover:border-brand-gold transition-colors" data-id="element-243">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-244">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" data-id="element-245"></path>
            </svg>
          </button>
          <button className="w-10 h-10 rounded-full border border-warm-brown/20 flex items-center justify-center text-warm-brown hover:bg-brand-gold hover:text-cream hover:border-brand-gold transition-colors" data-id="element-246">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-247">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" data-id="element-248"></path>
            </svg>
          </button>
        </div>

        {/* Services Grid (2-3 columns) */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-249">
          {services.slice(0, 3).map((service, index) => <motion.a href="tel:2409217857" key={service.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group block" data-id="element-250">
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-4 bg-warm-brown/5" data-id="element-251">
                <img src={service.image} alt={service.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-252" />
                <div className="absolute inset-0 bg-near-black/0 group-hover:bg-near-black/10 transition-colors duration-300" data-id="element-253"></div>
                {/* Category Label */}
                <div className="absolute top-4 left-4 bg-cream/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest text-warm-brown" data-id="element-254">
                  {service.name.includes('Locs') ? 'Locs' : service.name.includes('Cornrows') ? 'Cornrows' : 'Braids'}
                </div>
              </div>
              <div className="flex justify-between items-center" data-id="element-255">
                <h3 className="font-display text-2xl text-warm-brown group-hover:text-brand-gold transition-colors" data-id="element-256">
                  {service.name}
                </h3>
                <span className="font-body text-base font-medium text-near-black/60" data-id="element-257">
                  {service.price}
                </span>
              </div>
            </motion.a>)}
        </div>

        {/* Centered CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-258">
          <Link to="/services" className="inline-flex items-center justify-center px-8 py-3 bg-warm-brown text-cream font-bold text-sm rounded-full hover:bg-near-black transition-colors shadow-md" data-id="element-259">
            View Full Service Menu
          </Link>
        </motion.div>
      </div>
    </section>;
}